import React, { useMemo } from 'react';
import { Button, useDeviceType } from '@cian/ui-kit';
import { useLocation } from 'react-router-dom';

import { PaginationNew } from '../Pagination';
import { generatePagesData } from '../../utils';
import { ISettings } from '../../types/settings';
import s from './PaginationWithReadMore.css';

interface IPaginationWithReadMore {
  activeNumber: number;
  totalPages: number;
  onClick(page: number, type: ISettings['listingAppendType']): void;
  isDisabled?: boolean;
}

/**
 * Пагинация и кнопка "Показать еще"
 */
export const PaginationWithReadMore = ({ activeNumber, totalPages, onClick, isDisabled }: IPaginationWithReadMore) => {
  const deviceType = useDeviceType();
  const isPhone = () => deviceType === 'phone';
  const { search, pathname } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  if (totalPages <= 1 || totalPages < activeNumber) {
    return null;
  }

  return (
    <div className={s['wrapper']}>
      {activeNumber !== totalPages && (
        <Button
          theme={'fill_secondary'}
          fullWidth
          loading={isDisabled}
          onClick={() => onClick(activeNumber + 1, 'append')}
        >
          Показать больше
        </Button>
      )}

      <PaginationNew
        pages={generatePagesData({
          maxShownPages: isPhone() ? 3 : 5,
          showFirstPage: isPhone(),
          activeNumber,
          pathname,
          searchParams,
          totalPages,
        })}
        activeNumber={activeNumber}
        onClick={number => onClick(number, 'set')}
        isDisabled={isDisabled}
      />
    </div>
  );
};
